var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main", attrs: { id: "main" } },
    [
      _vm.$route.path !== "/pay" &&
      _vm.$route.path !== "/wx-code" &&
      _vm.$route.path !== "/home"
        ? _c("MainHead")
        : _vm._e(),
      _vm._v(" "),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }